import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { theme } from 'theme';

const CustomFormControl = withStyles({
  root: {
    width: '100%',
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 13px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.colors.primary.red,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary.red,
    },
  },
})(FormControl);

const CustomSelect = ({
  title,
  items,
  style,
  onChange,
  value,
  disabled = false,
}) => {
  return (
    <CustomFormControl variant="outlined" style={style} disabled={disabled}>
      <InputLabel id="demo-simple-select-outlined-label">{title}</InputLabel>
      <Select
        style={{ height: '40px', borderRadius: '1px' }}
        label={title}
        onChange={onChange}
        value={value}
      >
        {[{ value: null, label: '-' }].concat(items).map((item, idx) => (
          <MenuItem value={item.value} key={idx}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </CustomFormControl>
  );
};

export default CustomSelect;
